export default {
  fieldPrefixes: {
    filter: 'filter',
    find: 'find',
    start: 'start',
    end: 'end',
    earliest: 'earliest',
    latest: 'latest',
  },
  fieldSuffixes: {
    greaterThan: 'greater than',
  },
  invoice: {
    invoice: 'Invoice',
    sold_to: 'Sold to',
  },
  uploadedTicket: {
    sender: 'Sender',
  },
  payroll: {
    driver: 'Driver',
    total: 'Total',
  },
  printButtons: {
    summary: 'Summary',
    detail: 'Detail',
  },
  searchTitles: {
    tickets: 'Lookup ticket',
    locations: 'Lookup location',
  },
  revenue: {
    endDate: 'End:',
    startDate: 'Start:',
    byDate: 'by day',
  },
  phone: {
    helper: 'Format: +13175551234',
    formatInvalid: 'Must be format +13175551234',
  },
  ui: {
    tonnageTicketInvoiceShowDetail: {
      false: 'Show invoice tickets',
      true: 'Hide invoice tickets',
    },
  },
}
